import { render, staticRenderFns } from "./playersInforRadar.vue?vue&type=template&id=9fe45b66&scoped=true"
import script from "./playersInforRadar.vue?vue&type=script&lang=js"
export * from "./playersInforRadar.vue?vue&type=script&lang=js"
import style0 from "./playersInforRadar.vue?vue&type=style&index=0&id=9fe45b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe45b66",
  null
  
)

export default component.exports